import {
  __objRest,
  __spreadValues
} from "./chunk-LS752DCC.js";

// src/types/health-journey-common-asset-keys.types.ts
var HEALTH_JOURNEY_COMMON_ASSET_KEYS = /* @__PURE__ */ ((HEALTH_JOURNEY_COMMON_ASSET_KEYS2) => {
  HEALTH_JOURNEY_COMMON_ASSET_KEYS2["EMPTY_STATE_CONFIGURABLE_ACTIVITIES"] = "EMPTY_STATE_CONFIGURABLE_ACTIVITIES";
  HEALTH_JOURNEY_COMMON_ASSET_KEYS2["ENABLED_BADGE_PLACEHOLDER"] = "ENABLED_BADGE_PLACEHOLDER";
  HEALTH_JOURNEY_COMMON_ASSET_KEYS2["COMPLETED_PROGRAM"] = "COMPLETED_PROGRAM";
  HEALTH_JOURNEY_COMMON_ASSET_KEYS2["PROGRAM_HEADING_BANNER_ICON"] = "PROGRAM_HEADING_BANNER_ICON";
  HEALTH_JOURNEY_COMMON_ASSET_KEYS2["ACTIVITIES_CYCLING_ANIMATION"] = "ACTIVITIES_CYCLING_ANIMATION";
  return HEALTH_JOURNEY_COMMON_ASSET_KEYS2;
})(HEALTH_JOURNEY_COMMON_ASSET_KEYS || {});

// src/components/health-activity-modal.component.jsx
import * as React from "react";
import PropTypes from "prop-types";
import {
  QuietButton,
  genesisStyled,
  css
} from "@leagueplatform/genesis-commons";
import { Modal, Icon, ICONS, visuallyHidden } from "@leagueplatform/ui-kit";
import { useIntl } from "@leagueplatform/locales";
var CloseButton = genesisStyled(QuietButton)(
  css({
    position: "absolute",
    right: 0,
    margin: "one",
    padding: "half",
    zIndex: "modal"
  })
);
var CloseButtonScreenReaderText = genesisStyled.span(css(visuallyHidden));
var StyledModalContainer = genesisStyled(Modal.Container)(
  ({ isNarrow, styleOverrides }) => [
    css({
      backgroundColor: "surface.background.primary",
      position: "relative",
      maxWidth: isNarrow ? 500 : 620,
      borderRadius: "medium",
      overflow: "scroll"
    }),
    styleOverrides
  ]
);
var StyledModalBody = genesisStyled(Modal.Body)(
  ({ isNarrow, styleOverrides }) => [
    css({
      paddingY: isNarrow ? "oneAndHalf" : "twoAndHalf",
      paddingX: isNarrow ? "two" : "twoAndHalf"
    }),
    styleOverrides
  ]
);
var HealthActivityModal = (_a) => {
  var _b = _a, {
    onClose,
    children,
    isNarrow = false,
    styleOverrides = {}
  } = _b, props = __objRest(_b, [
    "onClose",
    "children",
    "isNarrow",
    "styleOverrides"
  ]);
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React.createElement(Modal.Wrapper, { onClose }, /* @__PURE__ */ React.createElement(
    StyledModalContainer,
    __spreadValues({
      isNarrow,
      styleOverrides: styleOverrides.container
    }, props),
    /* @__PURE__ */ React.createElement(CloseButton, { onClick: onClose }, /* @__PURE__ */ React.createElement(CloseButtonScreenReaderText, null, formatMessage({ id: "CLOSE" })), /* @__PURE__ */ React.createElement(Icon, { icon: ICONS.CLOSE, size: 16, "aria-hidden": "true" })),
    /* @__PURE__ */ React.createElement(
      StyledModalBody,
      {
        styleOverrides: styleOverrides.body,
        isNarrow
      },
      children
    )
  ));
};
HealthActivityModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isNarrow: PropTypes.bool,
  styleOverrides: PropTypes.shape({
    container: PropTypes.func,
    body: PropTypes.func
  })
};
HealthActivityModal.defaultProps = {
  isNarrow: false,
  styleOverrides: {
    container: () => void 0,
    body: () => void 0
  }
};

export {
  HEALTH_JOURNEY_COMMON_ASSET_KEYS,
  HealthActivityModal
};
//# sourceMappingURL=chunk-C6BNNSVL.js.map